import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {authenticationService} from "../../../services/AuthenticationService";
import SvGraphics from "../../../assets/SvGraphics";
import TreatmentPlanBlock from "../../../components/PatientOnboard/TreatmentPlanBlock";
import TreatmentPlanNotExpanded from "../../../components/PatientOnboard/TreatmentPlanNotExpanded";


class TreatmentTargetsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
            entry: this.props.entry,
            showTreatment: 0,
            patientTreatments: this.props.patientTreatments,
            currentTreatment: this.props.currentTreatment,
            titrationPlan: this.props.titrationPlan,
            isTitrationSchedule: false,
            choosenTargetsSymptoms: this.props.choosenTargetsSymptoms,
        };
    }

    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }

    componentDidMount() {
    }

    setTitrationSchedule = (val, index) => {
        if (val === "Titration") {
            this.setState({isTitrationSchedule: true})

        } else {
            this.props.getTitrationPlan("New", index)
            this.setState({isTitrationSchedule: false})

        }
        this.editTreatmentPlan("TreatmentSchedule", val, index)
    }
    changeView = (num) => {
        this.setState({view: this.state.view === num ? 0 : num});
    }


    getTitrationPlan = (val, index) => {
        this.props.getTitrationPlan(val, index)
    }


    addTreatmentPlan() {
        this.props.addTreatmentPlan()
    }

     getRecommendedTreatment() {
         this.props.getRecommendedTreatment()
    }




    showTreatment(index) {
        this.setState({showTreatment: index})
    }

    DeleteTreatment(index) {
        this.props.DeleteTreatment(index)
    }

    getSymptomsDesc = (Symptom_ID, lang) => {
        return this.props.getSymptomsDesc(Symptom_ID, lang)
    }

    editTreatmentPlan = (func, value, index) => {
        this.props.editTreatmentPlan(func, value, index)
    }
    getNewTitration = (initialDose, maxDosage, stepEach) => {
        this.props.getNewTitration(initialDose, maxDosage, stepEach)
    }

    getTargetSymptoms(index, item) {
        let targetSymptoms = this.props.symptoms
        let symptomsList = this.props.symptomsList
        let targetSymptomsChoosen = []
        let language = localStorage.getItem('language')

        for (let j = 0; j < targetSymptoms.length; j++) {
            if (targetSymptoms[j].Symptom_ID) {
                for (let i = 0; i < symptomsList.length; i++) {
                    if (symptomsList[i].Symptom_ID.toString() === targetSymptoms[j].Symptom_ID.substring(1)) {
                        targetSymptomsChoosen.push(
                            <div style={{display: 'flex'}}>
                                <input type={"checkbox"} className={"checkboxStyle-treatment-symptoms"}
                                       onClick={(event) => this.editTreatmentPlan("Symptom_ID", symptomsList[i].Symptom_ID, index)}
                                       checked={item.Symptom_ID ? item.Symptom_ID.includes(symptomsList[i].Symptom_ID) : ""}
                                />
                                {language === "he" ?
                                    <label
                                        className={'infoLabel-treatment-symptoms'}>{symptomsList[i].Symptom_description_he}</label> :
                                    <label
                                        className={'infoLabel-treatment-symptoms'}>{symptomsList[i].Symptom_description}</label>
                                }
                            </div>
                        )

                    }
                }
            }
        }

        return targetSymptomsChoosen
    }


    render() {
        let {view, entry, titrationPlan} = this.state
        let {t} = this.props
        let {patientTreatments} = this.props

        let treatmentsTest = patientTreatments.map((item, index) =>
            <TreatmentPlanNotExpanded title={t('patient_boarding.Treatment')}
                                      Component={TreatmentPlanBlock}
                                      treatmentIndex={index}
                                      current={item}
                                      t={(e) => this.props.t(e)}
                                      isExpanded={item.isExpanded}
                                      DeleteTreatment={(index) => this.DeleteTreatment(index)}
                                      getSymptomsDesc={(Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang)}
                                      rest={{
                                          treatmentIndex: index,
                                          onValueChange: (name, value) => this.onValueChange(name, value),
                                          getTitrationPlan: (val, index) => this.getTitrationPlan(val, index),
                                          setTitrationSchedule: (val, index) => this.setTitrationSchedule(val, index),
                                          getSymptomsDesc: (Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang),
                                          getTargetSymptoms: (index, item) => this.getTargetSymptoms(index, item),
                                          symptoms: this.props.symptoms,
                                          symptomsList: this.props.symptomsList,
                                          entry: this.props.entry,
                                          errors: this.props.errors,
                                          titrationPlans: this.props.titrationPlans,
                                          productsList: this.props.productsList,
                                          t: (e) => this.props.t(e),
                                          current: item,
                                          editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                      }}/>
        )

        return (

            <div className={'patientForm-box-container'}>
                <div className={'svg-label-treatment'}>
                    <SvGraphics className={"delete-icon"} svgname={'add-icon'} onClick={() => this.addTreatmentPlan("ADD","",0)}/>
                    <div className={'addTarget'} onClick={() => this.addTreatmentPlan()}>{t('patient_boarding.add_treatment_plan')}</div>
                </div>

                <div className={'RecommendTreatmentDiv'}>
{/*
                    <SvGraphics style={{width:'20px',height:'20px',marginTop:'12px'}} svgname={'idea'} onClick={() => this.getRecommendedTreatment("ADD","",0)}/>
*/}

                    <SvGraphics style={{width:'20px',height:'20px',marginTop:'12px'}} svgname={'idea'}/>


                    <div className={'RecommendTreatmentText'} >{t('patient_boarding.get_recommend_treatment_text')}</div>

                    <div className={'RecommendTreatmentButton'} onClick={() => this.getRecommendedTreatment()}>{t('patient_boarding.get_recommend_treatment')}</div>
                </div>
                {treatmentsTest}
            </div>
        );
    }
}


const TreatmentTargetsTab = compose(
    withTranslation(),
)(TreatmentTargetsTabComposed);

export default TreatmentTargetsTab;

